import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import PrescriptionDisplay from '../display/PrescriptionDisplay';
import printJS from 'print-js';
import PrintIcon from '@mui/icons-material/Print';

export default function PrescriptionPreview({open, onClose, prescription = null}) { 
    const handleClose = () => {
        onClose();
    };

    const handlePrint = () => {
      printJS({
        printable: 'print-section', // ID of the element to print
        type: 'html',
        targetStyles: ['*'], // include all CSS styles
      });
    };

    if (!prescription) {
      return (
          <></>
      );
    }

    return (
      <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            
          <DialogTitle>Prescription Preview</DialogTitle>
          <DialogContent dividers>
            <PrescriptionDisplay code={prescription.reference_code} />
          </DialogContent>
          <DialogActions>
            <Button onClick={handlePrint}>
              <PrintIcon />
            </Button>
            <div style={{flex: '1 0 0'}} />
            <Button onClick={handleClose}>Close</Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
}